import React from 'react'
import Slider from './Slider';

/* The company marquee that used to sit beside (and later under) the slider
   has been removed - MarqueeLComList is no longer rendered here. */

const HomeComponent = () => {
    return (
        <>
            <Slider />
        </>
    )
}

export default HomeComponent;
